import { TODO_LIST_SUCCESS } from "./TodoListConstant";
 
export const toDoListReducer = (state = { toDoListData: [] }, action) => {

    switch (action.type) {
        case TODO_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                toDoListData: action.payload,
            }
        default:
            return state;
    }

}



